var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdult = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "adult",
    fillRule: "nonzero",
    fill: "#4A4A4A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(13.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.695,6.498 C4.182,8.094 5.433,9.753 7.12,9.753 C8.807,9.753 10.06,8.093 10.544,6.498 C10.96,6.354 11.308,5.938 11.444,5.4 C11.631,4.66 11.357,3.976 10.824,3.77 C10.8729906,3.57273759 10.8978392,3.37025479 10.898,3.167 C10.898,1.415 9.152,0 6.998,0 C4.844,0 3.092,1.418 3.092,3.167 C3.092,3.417 3.132,3.659 3.197,3.892 C2.812,4.182 2.637,4.772 2.795,5.402 C2.931,5.938 3.279,6.354 3.695,6.498 Z M3.435,4.463 C3.48274136,4.37598498 3.56287068,4.3113066 3.658,4.283 C3.69363286,4.27659535 3.72999099,4.27524876 3.766,4.279 L4.036,4.299 L4.076,4.033 C4.14766793,3.51293009 4.31624931,3.01091712 4.573,2.553 C5.028,3.067 5.933,3.415 6.978,3.415 C8.158,3.415 9.163,2.969 9.534,2.347 C9.86486988,2.8548311 10.0793248,3.42955673 10.162,4.03 L10.202,4.296 L10.472,4.27 C10.507286,4.26642103 10.5428741,4.2670925 10.578,4.272 C10.598,4.275 10.608,4.289 10.628,4.295 C10.873,4.402 10.998,4.83 10.892,5.255 C10.785,5.687 10.502,5.942 10.278,5.97 L10.09,6 L10.04,6.18 C9.636,7.67 8.5,9.18 7.117,9.18 C5.73,9.18 4.597,7.673 4.197,6.18 L4.145,6 L3.959,5.975 C3.732,5.947 3.449,5.687 3.341,5.259 C3.271,4.949 3.314,4.642 3.436,4.459 L3.435,4.463 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.107,9.894 C7.96,10.48 7.107,10.956 7.107,10.956 L7.077,10.933 C5.56951903,10.5231087 5.62670198,10.1715791 5.075,9.889 C4.522,9.603 4.103,9.083 3.738,8.469 C2.042,9.156 0.858,10.744 0.858,12.125 L0.858,15 L13.32,15 L13.32,12.13 C13.326,10.75 12.14,9.164 10.445,8.474 C10.083,9.091 9.665,9.614 9.107,9.894 Z",
    id: "Shape"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdult);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/adult.432077dc2cd74b8edab3c0a8078adcf4.svg";